import type { Order } from "@jti/magento";
import { useSelector } from "@jti/store/reduxHooks";
import { fetchCartPrices, fetchTrialCartPrices } from "@jti/store/slices/cartSlice";

import useCurrentPrice from "@checkout/hooks/useCurrentPrice";
import { useFreeTrial } from "@checkout/hooks/useFreeTrial";

export const usePrice = (selectedOrderDetails: Order | undefined | null, isStandardCheckoutFlow: boolean) => {
  const { isFreeTrial, freeTrialId } = useFreeTrial();
  const trialCartPrices = useSelector((state) => state.freeTrialCart.prices);
  const { id: cartId, prices: cartPrices } = useSelector((state) => state.cart);
  const prices = useCurrentPrice(isFreeTrial, isStandardCheckoutFlow, selectedOrderDetails);

  return {
    cartId: isFreeTrial ? freeTrialId : cartId,
    isFreeTrial,
    prices,
    pricesFetchStatus: isFreeTrial ? trialCartPrices.fetchStatus : cartPrices.fetchStatus,
    fetchCurrentPrices: isFreeTrial ? fetchTrialCartPrices : fetchCartPrices,
  };
};
